module.exports = __webpack_public_path__ + "static/media/back_reset.59c1b3c4.svg";